module.exports = __webpack_public_path__ + "media/images/sandbox/mario-7d7b5bc4563081562e9b5ce9c7db304a.png";